import { HELPKIT_AUTH_PATH } from "@/constants/helpkit";

// Only the HelpKit hop (exact path, optional query) leaves the SPA: the
// function serves it, and only a document navigation carries the refresh
// cookie there.
export type LoginRedirect =
  | { kind: "spa"; to: string }
  | { kind: "document"; href: string };

export function resolveLoginRedirect(redirect?: string): LoginRedirect {
  return redirect === HELPKIT_AUTH_PATH ||
    redirect?.startsWith(`${HELPKIT_AUTH_PATH}?`)
    ? { kind: "document", href: redirect }
    : { kind: "spa", to: redirect || "/" };
}

export type LoginEntry = { kind: "form" | "reset" } | LoginRedirect;

// `reauth` (the hop's retry link) drops a stale local session and shows the
// form instead of bouncing straight back to the hop.
export function resolveLoginEntry(args: {
  isAuthenticated: boolean;
  redirect?: string;
  reauth?: boolean;
}): LoginEntry {
  if (!args.isAuthenticated) return { kind: "form" };
  return args.reauth ? { kind: "reset" } : resolveLoginRedirect(args.redirect);
}
